import { render, staticRenderFns } from "./QuarterlySales.vue?vue&type=template&id=5485c936&scoped=true&"
import script from "./QuarterlySales.vue?vue&type=script&lang=js&"
export * from "./QuarterlySales.vue?vue&type=script&lang=js&"
import style0 from "./QuarterlySales.vue?vue&type=style&index=0&id=5485c936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485c936",
  null
  
)

export default component.exports